import applyToUIControls from './apply-to-ui-controls';

import TableController from 'utils/table-controller';

const CLASSNAME_CONTENT = '.js-forecast-table-content';
const DEFAULT_MODE = 'p';

function getInitialMode(table) {
  const { interval } = table.dataset;

  switch (interval) {
    case 'six_day':
      return 'p';
    case 'two_day':
      return 't';
    default:
      return DEFAULT_MODE;
  }
}

function initTableController(container) {
  const tableContent = container.querySelector(CLASSNAME_CONTENT);
  const initialMode = getInitialMode(tableContent);

  const tableController = new TableController(
    {
      basic: {},
      local: {},
      global: {},
      weather: {},
      advanced: {},
    },
    {
      initialMode,
    }
  ).makeColumns(tableContent);

  const columnsBody = tableController.splitRowsByColumns(
    tableContent.tBodies[0].rows
  );
  const columnsFooter = tableController.splitRowsByColumns(
    tableContent.tFoot.rows
  );

  tableController
    .connectContent('basic', tableContent.tBodies[0], columnsBody)
    .connectContent('weather', tableContent.tFoot, columnsFooter)
    .fetchData((error, tables) => {
      if (error) {
        console.error(error); /* eslint-disable-line no-console */
        return;
      }

      ['advanced', 'local', 'global'].forEach(tableName => {
        const table = tables[tableName];
        const part = table.nodes[initialMode].content;
        const columns = tableController.splitRowsByColumns(part.rows);

        tableController.connectContent(tableName, part, columns);
      });
    });

  applyToUIControls(
    container,
    tableController.changeMode.bind(tableController),
    tableController.replaceTable.bind(tableController)
  );

  window.tableController = tableController;
}

export default initTableController;
